import {FormValues} from "../../recebiveis/types";
import {getAxiosInstance} from "../../../../services/providers/api";
import {getErrorMessage} from "../../../../utils/getErrorMessage";

export default class SalesService {
  getSales = async (
    page:number,
    pageSize:number,
    filter?:FormValues
  )=> {
    const selectedCompany: string | null = localStorage.getItem("selectedCompany");
    let parsedSelectedCompany = null;
    if (selectedCompany) parsedSelectedCompany = JSON.parse(selectedCompany);

    const paged = true;
    const merchantId = parsedSelectedCompany ? parsedSelectedCompany.merchantId : filter?.merchantId !== undefined && filter?.merchantId.length > 0 ? filter?.merchantId : null;
    const startDate = filter?.startDate || null;
    const finishDate = filter?.finishDate || null;
    const brand = filter?.brand || null;
    const acquirerNsu = filter?.acquirerNsu || null;
    const acquirer = filter?.acquirer !== -1 ? filter?.acquirer : null;
    const productName = filter?.productName || null;
    const isAdmin = filter?.isAdmin;

    try {
      const response = await getAxiosInstance().get('/settlement-detail/get-settlement-sales', {
        params: {
          offset: page,
          pageSize: pageSize,
          paged: paged,
          startDate: startDate,
          finishDate: finishDate,
          merchantId: merchantId,
          brand: brand,
          acquirerNsu: acquirerNsu,
          acquirer: acquirer,
          productName: productName,
          isAdmin: isAdmin
        }
      });

      return response.data.response;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }
  }

  downloadVendasXls = async (
    page:number,
    pageSize:number,
    filter?:FormValues
  )=> {
    const selectedCompany: string | null = localStorage.getItem("selectedCompany");
    let parsedSelectedCompany = null;
    if (selectedCompany) parsedSelectedCompany = JSON.parse(selectedCompany);

    const paged = false;
    const merchantId = parsedSelectedCompany ? parsedSelectedCompany.merchantId : filter?.merchantId !== undefined && filter?.merchantId.length > 0 ? filter?.merchantId : null;
    const startDate = filter?.startDate || null;
    const finishDate = filter?.finishDate || null;
    const brand = filter?.brand || null;
    const acquirerNsu = filter?.acquirerNsu || null;
    const acquirer = filter?.acquirer !== -1 ? filter?.acquirer : null;
    const productName = filter?.productName || null;
    const isAdmin = filter?.isAdmin;
    const commercialHierId = filter?.commercialHierId !== -1 ? filter?.commercialHierId : null;
    const parcels = filter?.parcels !== -1 ? filter?.parcels : null;

    try {
      const response = await getAxiosInstance().get('/settlement-detail/settlement-sales-xls', {
        params: {
          offset: page,
          pageSize: pageSize,
          paged: paged,
          startDate: startDate,
          finishDate: finishDate,
          merchantId: merchantId,
          brand: brand,
          acquirerNsu: acquirerNsu,
          acquirer: acquirer,
          productName: productName,
          isAdmin: isAdmin,
          commercialHierId: commercialHierId,
          parcels: parcels
        },
        responseType: 'arraybuffer'
      });

      return new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }
  }

}
